<template>
    <GeneralDialog v-model="visible" title="Setting">
        <div class="setting">
            <div class="person">
                <div class="avatar"><img :src="personInfo.avatar" /></div>
                <div class="des">
                    <div class="id">ID:{{ personInfo.uid }}</div>
                    <div class="name">{{ decodeName(personInfo.nickname) }}</div>
                </div>
            </div>
            <div class="tip">{{ $t('copartner_team_set1') }}</div>
            <div class="control">
                {{ $t('copartner_player_set3') }}
                <van-field v-model="count" type="digit" />
                %
            </div>
            <!-- <div class="warn-tip">20% ≤ Commission rate ≤ 50%</div> -->
            <div class="btn-wrap">
                <div :class="['btn', { active: count }]" @click="handleConfirm">{{ $t('Confirm') }}</div>
            </div>
        </div>
    </GeneralDialog>
</template>
<script setup lang="tsx">
import GeneralDialog from '@/components/dialog/generalDialog.vue'
import { decodeName } from '@/utils'
import { useI18n } from 'vue-i18n'
import { setCopartnerRate, changeCopartnerRate } from '@/api/partner'
import { useBaseStore } from '@/stores'

const props = defineProps({
    info: {
        type: Object,
        default: () => ({}),
    },
    index: {
        type: Number,
        default: () => 0,
    },
    type: {
        type: Number,
        default: () => 0,
    },
})
const emits = defineEmits(['success'])
const visible = defineModel()
const i18n = useI18n()
const personInfo = computed(() => props.info?._source || {})
const count = ref('')
const store = useBaseStore()
const apiData = props.type === 0 ? setCopartnerRate : changeCopartnerRate
const handleConfirm = () => {
    const { nickname, uid, context } = personInfo.value
    const num = +count.value
    showDialog({
        message: i18n.t('copartner_team_set2', {
            username: decodeName(nickname),
            number: num + '%',
        }),
        className: 'common-dialog',
        showCancelButton: true,
        confirmButtonText: i18n.t('Confirm'),
        cancelButtonText: i18n.t('Cancel'),
        zIndex: 3002,
    })
        .then(() => {
            apiData({
                uid: uid || context.uid,
                rate: num / 100,
            }).then((res) => {
                if (res.code === 200) {
                    visible.value = false
                    if (props.type === 1) {
                        emits('success', {
                            index: props.index,
                            num: num / 100,
                        })
                    }
                } else {
                    store.showFailToast(i18n.t('copartner_player_set4'))
                }
            })
        })
        .catch((e) => {
            console.log(e, 'Cancel')
        })
}
</script>
<style lang="scss" scoped>
.setting {
    padding: 18px 34px 0;
    min-height: 605px;
    font-family: MicrosoftYaHei;
    color: #fff;

    .person {
        @apply flex items-center;
        margin: 25px 0;
        .avatar {
            margin-right: 23px;
            width: 108px;
            height: 108px;
            border: solid 6px #8e80a8;
            border-radius: 50%;
            overflow: hidden;
            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
        }
        .des {
            @apply flex flex-col justify-center;
            font-size: 30px;
            .name {
                font-size: 24px;
                color: #8e80a8;
            }
        }
    }
    .tip {
        line-height: 48px;
        font-size: 24px;
    }
    .control {
        @apply flex items-center justify-center;
        margin: 42px 0;
        font-size: 30px;
        :deep(.van-cell) {
            margin: 0 20px;
            width: 180px;
            height: 80px;
            background-color: #2f213b;
            border-radius: 20px;

            .van-field__control {
                font-size: 36px;
                color: #ffc22b;
                text-align: center;
            }
        }
    }
    .warn-tip {
        @apply flex justify-center;
        margin-bottom: 26px;

        font-size: 24px;
        color: #ff5688;

        &::before {
            display: inline-block;
            content: '';
            margin-right: 10px;
            width: 34px;
            height: 30px;
            background: url('@/assets/img/wallets/exclam_mark.png') no-repeat;
            background-size: 100% 100%;
        }
    }
    .btn-wrap {
        position: relative;
        padding: 40px 0 60px;
        &::before {
            position: absolute;
            top: 0;
            left: 0;
            content: '';
            width: 100%;
            height: 4px;
            background-color: #665682;
            border-radius: 2px;
        }
        .btn {
            @apply flex justify-center items-center;
            margin: 0 auto;
            width: 440px;
            height: 88px;
            background-image: linear-gradient(0deg, #fa3374 0%, #fd578d 60%, #ff7aa5 100%), linear-gradient(#e59e20, #e59e20);
            background-blend-mode: normal, normal;
            border-radius: 44px;
            font-size: 36px;
            font-weight: bold;
            pointer-events: none;
            opacity: 0.6;
            &.active {
                opacity: 1;
                pointer-events: auto;
            }
        }
    }
}
</style>
